module.exports = __webpack_public_path__ + "img/7_193.ca63f704.png";